import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: CustomHttpService) { }

  /**
   * Get all contacts with count and pagination
   * @param data - Contains organization_id, page, limit, where, order, filter
   * @returns Observable with contacts data
   */
  getAllContactsWithCount(data: any): Observable<any> {
    return this.http.post(environment.getAllContactsWithCount, data);
  }

  /**
   * Create a new contact
   * @param data - Contact data including all required fields
   * @returns Observable with created contact
   */
  createContact(data: any): Observable<any> {
    return this.http.post(environment.createContact, data);
  }

  /**
   * Update an existing contact
   * @param data - Contact data with id and fields to update
   * @returns Observable with updated contact
   */
  updateContact(data: any): Observable<any> {
    return this.http.post(environment.updateContact, data);
  }

  /**
   * Delete a contact
   * @param data - Object containing contact id
   * @returns Observable with deletion result
   */
  deleteContact(data: any): Observable<any> {
    return this.http.post(environment.deleteContact, data);
  }

  /**
   * Get a single contact by id
   * @param data - Object containing contact id
   * @returns Observable with contact data
   */
  getContactById(data: any): Observable<any> {
    return this.http.post(environment.getContactById, data);
  }
}
